export type IncidentStatus = 'active' | 'acknowledged' | 'resolved';

export type Incident = {
  id: string;
  passenger: string;
  vehicle: string;
  lat: number;
  lng: number;
  time: string;
  status: IncidentStatus;
  note: string;
};

export const demoIncidents: Incident[] = [
  {
    id: 'INC-2842',
    passenger: 'Chioma Eze',
    vehicle: 'LAG-234-AB',
    lat: 6.4321,
    lng: 3.4567,
    time: '3 min ago',
    status: 'active',
    note: 'Panic button pressed during VI Loop trip',
  },
  {
    id: 'INC-2841',
    passenger: 'Folake Adebayo',
    vehicle: 'LAG-105-CD',
    lat: 6.4502,
    lng: 3.4101,
    time: '12 min ago',
    status: 'acknowledged',
    note: 'Reported unsafe driving',
  },
  {
    id: 'INC-2840',
    passenger: 'Segun Adekunle',
    vehicle: 'LAG-712-GH',
    lat: 6.4218,
    lng: 3.4022,
    time: '1 hour ago',
    status: 'resolved',
    note: 'Resolved on-site by responder team Alpha',
  },
  {
    id: 'INC-2839',
    passenger: 'Tunde Bello',
    vehicle: 'LAG-558-EF',
    lat: 6.4413,
    lng: 3.4378,
    time: '3 hours ago',
    status: 'resolved',
    note: 'False alarm - accidental press',
  },
];
